import React from "react";
import PropTypes from "prop-types";

function ContextChoice({
  contexts,
  onSelect,
  disabled,
  error,
  onCancel,
  cancelLabel,
}) {
  return (
    <div className="quiz-text">
      {error && (
        <div role="alert" className="alert alert-danger">
          {error}
        </div>
      )}
      <h2><strong>Wybierz konto</strong></h2>
      <div className="row">
        {contexts.map(context => (
          <div className="col-md-4 mb-2" key={context.contextKey}>
            <button
              type="button"
              data-context-key={context.contextKey}
              className="btn manage-button manage-red-button btn-block"
              disabled={disabled}
              onClick={() => onSelect(context)}
            >
              {context.label}
            </button>
          </div>
        ))}
      </div>
      {onCancel && (
        <button
          type="button"
          className="btn manage-button manage-teal-button mt-2"
          disabled={disabled}
          onClick={onCancel}
        >
          {cancelLabel}
        </button>
      )}
    </div>
  );
}

ContextChoice.propTypes = {
  contexts: PropTypes.arrayOf(PropTypes.shape({
    contextKey: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    schoolId: PropTypes.string,
  })).isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  onCancel: PropTypes.func,
  cancelLabel: PropTypes.string,
};

ContextChoice.defaultProps = {
  disabled: false,
  error: "",
  onCancel: null,
  cancelLabel: "Anuluj",
};

export default ContextChoice;
